(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/place-bet.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/place-bet.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

svs = svs || {};
svs.components = svs.components || {};
svs.components.sport = svs.components.sport || {};
svs.components.sport.quickplayModal = svs.components.sport.quickplayModal || {};
svs.components.sport.quickplayModal.internal = svs.components.sport.quickplayModal.internal || {};
const logger = new svs.core.log.Logger('svs.sport.QuickplayModal');
const {
  useEffect,
  useRef
} = React;
const {
  api: DialogApi,
  Confirm: ConfirmDialog
} = svs.ui.dialog;
const {
  CurrencyAsJupiterString
} = svs.utils.format;
const {
  getDisplayName,
  resolveITSProductId,
  productIds
} = svs.utils.products;
const {
  showErrorDialog
} = svs.sport.sport_common;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  getProductDisplayName,
  getProductCompetitionId,
  getProductBrand
} = svs.components.lbUtils.brandMapping.fn;
const {
  getRacingDisplayName,
  getRacingClassName
} = svs.utils.racing;
const {
  getPaymentConfirmMessage
} = svs.components.sport;
const {
  isMarketplaceWallet
} = svs.components.tipsen.wallet.walletHelpers;
const {
  getTeamUrl
} = svs.components.marketplace.helpers;
const WEIGHTED_QUICK_PICK_VALUE = 'WEIGHTEDQP';
const NUM_DRAWS = 1;
const ROW_PRICE_MULTI = 1;
const SYSTEM_M_PREFIX = 'M'; 
const SYSTEM_TYPE_MATHEMATICAL = 'MSYS'; 
const BET_PROPERTIES_MARKETPLACE = 'GROUP';
const BET_PROPERTIES_XPERTEN = 'XPERTEN';
const ERROR_LOGGED_INTO_SAM_BUT_NOT_ASM = 3107;
const ERROR_NOT_LOGGED_IN = 100005;
const ERROR_STOPPED_SALE = 8124;
const ERROR_PENDING_OR_CLOSED_DRAW = 810;
const ERROR_BAD_DRAWSTATE = 8105;
const SYSTEM_NUM_REPLACEMENT_FOR_INCORRECT_DATA_FROM_XPERT_API = 1;
const {
  BOMBEN,
  CHALLENGE,
  MALTIPSET,
  FULLTRAFF,
  T8,
  T8EXTRA,
  T8STRYK,
  EUROPATIPSET,
  STRYKTIPSET,
  POWERPLAY,
  RACING
} = svs.utils.products.productIds;
const _getErrorDialogData = error => {
  const dialog = Object.seal({
    title: '',
    message: ''
  });
  const errorCode = parseInt(String(error.code).replace(/\s/g, ''), 10);
  switch (errorCode) {
    case ERROR_LOGGED_INTO_SAM_BUT_NOT_ASM:
      svs.core.userSession.logout();
      dialog.title = 'Du måste logga in för att lägga ditt spel';
      break;
    case ERROR_NOT_LOGGED_IN:
      dialog.title = 'Du måste logga in för att lägga ditt spel';
      break;
    case ERROR_STOPPED_SALE:
    case ERROR_BAD_DRAWSTATE:
      dialog.title = 'Omgången är stängd för spel';
      dialog.message = 'Försök senare';
      break;
    case ERROR_PENDING_OR_CLOSED_DRAW:
      if (String(error.message).includes('DEFINED')) {
        dialog.title = 'Omgången har inte öppnat för spel än';
        dialog.message = 'Försök senare';
      } else {
        dialog.title = 'Omgången har stängt';
      }
      break;
    default:
  }
  return dialog;
};
const getNewPaymentFlowSupported = productId => {
  switch (productId) {
    case BOMBEN:
    case CHALLENGE:
    case FULLTRAFF:
    case T8:
    case T8STRYK:
    case T8EXTRA:
    case EUROPATIPSET:
    case POWERPLAY:
    case STRYKTIPSET:
    case MALTIPSET:
      return true;
    default:
      return false;
  }
};

svs.components.sport.quickplayModal.internal._placeBetNormally = _ref => {
  let {
    pixData,
    closeCallback,
    wallet
  } = _ref;
  const {
    productId,
    drawNumber,
    systemCost
  } = pixData;
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const productName = productId === RACING ? getRacingDisplayName(productId) : getDisplayName(productId);
  if (!productName) {
    logger.error("Error in placeBet: Invalid productId (".concat(productId, ")"));
    return;
  }
  const wagerToPay = svs.components.sport.quickplayModal.internal._prepareWagerToPay({
    pixData,
    wallet
  });
  const wagerProductId = resolveITSProductId(productId) || '';
  if (!wagerProductId) {
    logger.info('Warning in placeBet: Sending wager without productID');
  }
  let extraTipsetName;
  if (productId === productIds.EUROPATIPSET) {
    extraTipsetName = getProductDisplayName(productId);
  }
  const getDialogProductName = () => extraTipsetName || productName;
  const wagerProps = {
    productId: wagerProductId,
    message: getPaymentConfirmMessage({
      productName: getDialogProductName(),
      amount: systemCost,
      marketplaceGroup: isMarketplaceWallet(wallet) ? wallet.label : null
    }),
    extradata: {
      system: "".concat(SYSTEM_M_PREFIX, " ").concat(systemCost),
      bag: "".concat(systemCost, ":").concat(productName, " ").concat(systemCost),
      quickpick: WEIGHTED_QUICK_PICK_VALUE
    }
  };
  let marketplaceUrl = '';
  if (isMarketplaceWallet(wallet)) {
    wagerProps.marketplaceAccount = {};
    wagerProps.marketplaceAccount.activatedDrawId = wallet.meta.ActivatedDrawId;
    wagerProps.marketplaceAccount.balance = wallet.meta.Balance;
    wagerProps.extradata.shares = true;
    wagerProps.extradata.typeOfShares = 'c2c';
    marketplaceUrl = "".concat(svs.core.urlMapping.get('marketplace')).concat(getTeamUrl(wallet.meta.GroupId, wallet.meta.GroupName, 'spel', wallet.meta.ContainerId, wallet.meta.ActivatedDrawId));
  }
  const _successCallback = _ref2 => {
    let {
      compDesc
    } = _ref2;
    if (closeCallback) {
      closeCallback();
    }
    svs.components.sport.quickplayModal.hooks.unsetPixFromCache({
      pixData
    });
    svs.components.sport.getPaymentDoneMessage({
      productName: getDialogProductName(),
      amount: systemCost,
      marketplaceUrl,
      compDesc
    }, _ref3 => {
      let {
        paymentDoneDialogConfig
      } = _ref3;
      DialogApi.add(new ConfirmDialog(paymentDoneDialogConfig));
    });
  };
  const _errorCallback = _ref4 => {
    let {
      error
    } = _ref4;
    const {
      title,
      message
    } = _getErrorDialogData(error);
    showErrorDialog(title, message, svs.components.dialog.type.DEFAULT);
    logger.info("Error in payment: ".concat(error.code, ": ").concat(error.message));
  };
  const isM64 = systemCost === 64;
  const tipssmCompetitionId = getProductCompetitionId(productId);
  if (isM64 && isLoggedIn && tipssmCompetitionId) {
    svs.components.sport.quickplayModal.participateInTipsSM({
      productId,
      productName: getDialogProductName(),
      drawNumber,
      competitionId: tipssmCompetitionId,
      wagerToPay,
      wagerProps,
      systemCost,
      successCallback: _successCallback,
      errorCallback: _errorCallback
    });
    return;
  }
  svs.lbUtils.wager.pay(wagerToPay, wagerProps, _successCallback, _errorCallback);
};

svs.components.sport.quickplayModal.internal._placeBetSelfService = _ref5 => {
  let {
    drawData,
    pixData,
    raceData,
    closeCallback,
    unlockPaymentFlow
  } = _ref5;
  if (!drawData && !raceData && !pixData) {
    unlockPaymentFlow();
    return;
  }
  let regCloseTime;
  if (drawData) {
    regCloseTime = drawData.regCloseTime;
  } else if (raceData) {
    regCloseTime = raceData.closeTime;
  }
  const {
    productId,
    systemCost
  } = pixData;
  const {
    generateProductItem
  } = svs.components.selfserviceCart;
  const wagerToPay = svs.components.sport.quickplayModal.internal._prepareWagerToPay({
    pixData,
    wallet: null
  });
  let description = '';
  if (regCloseTime) {
    try {
      description = "Spelstopp: ".concat(formatDate(new Date(regCloseTime), true, true));
    } catch (_unused) {
      logger.info("Error parsing regCloseTime \"".concat(regCloseTime, "\""));
    }
  }
  const productBrand = productId === RACING ? getRacingClassName(productId) : getProductBrand(productId);
  const productName = productId === RACING ? getRacingDisplayName(productId) : getDisplayName(productId);
  const wagerWrapper = generateProductItem({
    wagers: [wagerToPay],
    headers: {
      source: 'SvS:LB:ITS'
    },
    isLive: false,
    productBrand,
    productFlag: productId,
    productTitle: productName,
    cost: systemCost,
    description
  });
  svs.components.selfserviceCart.getCartInstance().actions.addItem(wagerWrapper, () => {
    svs.components.sport.quickplayModal.hooks.unsetPixFromCache({
      pixData
    });
    unlockPaymentFlow();
    if (closeCallback) {
      closeCallback();
    }
  });
};

svs.components.sport.quickplayModal.internal._prepareWagerToPay = _ref6 => {
  let {
    pixData,
    wallet
  } = _ref6;
  const {
    productId,
    drawNumber,
    systemCost,
    wagerBoardData
  } = pixData;
  const wagerProductId = resolveITSProductId(productId) || '';
  if (!wagerProductId) {
    logger.info('Warning in placeBet: Sending wager without productID');
  }
  const bet = {
    productId: wagerProductId,
    drawNum: drawNumber,
    numDraws: NUM_DRAWS,
    betAmountSalesGroup1: CurrencyAsJupiterString(systemCost),
    betAmountSalesGroup2: '0,00',
    rowPriceMulti: ROW_PRICE_MULTI,
    betProperties: []
  };
  if (wagerBoardData.fulltraff) {
    bet.scoreBoards = [{
      systemType: SYSTEM_TYPE_MATHEMATICAL,
      boardData: wagerBoardData.fulltraff,
      boardProps: [WEIGHTED_QUICK_PICK_VALUE],
      rowPriceMulti: ROW_PRICE_MULTI
    }];
  }
  if (wagerBoardData.bomben) {
    bet.expertenBoardData = {
      eventResults: wagerBoardData.bomben
    };
    bet.betProperties.push(BET_PROPERTIES_XPERTEN);
  }
  if (wagerBoardData.game1X2) {
    bet.game1X2Boards = [{
      boardData: wagerBoardData.game1X2,
      systemType: [SYSTEM_TYPE_MATHEMATICAL],
      boardProps: [WEIGHTED_QUICK_PICK_VALUE],
      rowPriceMulti: ROW_PRICE_MULTI,
      numSelections: systemCost,
      systemNum: SYSTEM_NUM_REPLACEMENT_FOR_INCORRECT_DATA_FROM_XPERT_API
    }];
  }
  if (wagerBoardData.maltipset) {
    bet.numberBoards = wagerBoardData.maltipset.map(board => _objectSpread(_objectSpread({}, board), {}, {
      systemType: [SYSTEM_TYPE_MATHEMATICAL],
      boardProps: [WEIGHTED_QUICK_PICK_VALUE],
      rowPriceMulti: ROW_PRICE_MULTI,
      systemNum: 1
    }));
  }
  if (wagerBoardData.expertenBoardData) {
    bet.expertenBoardData = wagerBoardData.expertenBoardData;
    bet.betProperties.push(BET_PROPERTIES_XPERTEN);
  }
  if (wagerBoardData.racing) {
    bet.rowPriceMulti = wagerBoardData.racing.rowPriceMulti;
    bet.rxBoards = wagerBoardData.racing.rxBoards;
    bet.subProductId = wagerBoardData.racing.subProductId;
  }
  if (isMarketplaceWallet(wallet)) {
    bet.betProperties.push(BET_PROPERTIES_MARKETPLACE);
  }
  return {
    crc: 0,
    marketInfo: 0,
    bagType: 0,
    bets: [bet],
    drawNum: drawNumber
  };
};


const usePlaceBet = () => {
  const inProgress = useRef(false);
  useEffect(() => () => {
    inProgress.current = false;
  }, []);
  const placeBet = _ref7 => {
    var _svs$core$config$data;
    let {
      drawData,
      pixData,
      closeCallback,
      wallet,
      raceData,
      rowPrice
    } = _ref7;
    if (inProgress.current) {
      return;
    }
    inProgress.current = true;
    if (!pixData) {
      logger.info('Warning in placeBet: No pixData available');
      return;
    }
    const unlockPaymentFlow = () => {
      inProgress.current = false;
    };
    const isSelfService = ((_svs$core$config$data = svs.core.config.data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.isSelfService) || false;
    if (isSelfService) {
      svs.components.sport.quickplayModal.internal._placeBetSelfService({
        drawData,
        raceData,
        pixData,
        closeCallback,
        unlockPaymentFlow
      });
    } else {
      const {
        productId
      } = pixData;
      const isSupported = getNewPaymentFlowSupported(productId);
      if (isSupported) {
        return svs.components.sport.quickplayModal.placeBetNewPaymentFlow({
          pixData,
          closeCallback,
          unlockPaymentFlow,
          wallet,
          rowPrice
        });
      }
      svs.components.sport.quickplayModal.internal._placeBetNormally({
        pixData,
        closeCallback,
        wallet
      });
    }
  };
  return {
    placeBet,
    isPlaceBetInProgress: inProgress.current
  };
};
svs.components.sport.quickplayModal.usePlaceBet = usePlaceBet;

 })(window);